import { ValidationError } from "@common/types";

export class EvalModelBuilderViewModel
{
    opened: boolean = false;

    goalName: string | null = null;
    operationInProgress: boolean = false;

    errors: ValidationError[] = [];

    show()
    {
        this.goalName = null;
        this.operationInProgress = false;
        this.clearValidationErrors();

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.goalName = null;
        this.operationInProgress = false;
        this.clearValidationErrors();
    }

    displayValidationErrors(errors: ValidationError[])
    {
        this.errors = errors;
        this.operationInProgress = false;
    }

    clearValidationErrors()
    {
        this.errors = [];
    }
}